var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import * as React from "react";
import { calculateRgba } from "./helpers/colors";
import { parseLengthAndUnit, cssValue } from "./helpers/unitConverter";
import { createAnimation } from "./helpers/animation";

function HashLoader(_a) {
  var _b = _a.loading,
      loading = _b === void 0 ? true : _b,
      _c = _a.color,
      color = _c === void 0 ? "#000000" : _c,
      _d = _a.speedMultiplier,
      speedMultiplier = _d === void 0 ? 1 : _d,
      _e = _a.cssOverride,
      cssOverride = _e === void 0 ? {} : _e,
      _f = _a.size,
      size = _f === void 0 ? 50 : _f,
      additionalprops = __rest(_a, ["loading", "color", "speedMultiplier", "cssOverride", "size"]);

  var _g = parseLengthAndUnit(size),
      value = _g.value,
      unit = _g.unit;

  var wrapper = __assign({
    display: "inherit",
    position: "relative",
    width: cssValue(size),
    height: cssValue(size),
    transform: "rotate(165deg)"
  }, cssOverride);

  var thickness = value / 5;
  var lat = (value - thickness) / 2;
  var offset = lat - thickness;
  var colorValue = calculateRgba(color, 0.75);
  var before = createAnimation("HashLoader", "0% {width: ".concat(thickness, "px; box-shadow: ").concat(lat, "px ").concat(-offset, "px ").concat(colorValue, ", ").concat(-lat, "px ").concat(offset, "px ").concat(colorValue, "}\n    35% {width: ").concat(cssValue(size), "; box-shadow: 0 ").concat(-offset, "px ").concat(colorValue, ", 0 ").concat(offset, "px ").concat(colorValue, "}\n    70% {width: ").concat(thickness, "px; box-shadow: ").concat(-lat, "px ").concat(-offset, "px ").concat(colorValue, ", ").concat(lat, "px ").concat(offset, "px ").concat(colorValue, "}\n    100% {box-shadow: ").concat(lat, "px ").concat(-offset, "px ").concat(colorValue, ", ").concat(-lat, "px ").concat(offset, "px ").concat(colorValue, "}"), "before");
  var after = createAnimation("HashLoader", "0% {height: ".concat(thickness, "px; box-shadow: ").concat(offset, "px ").concat(lat, "px ").concat(color, ", ").concat(-offset, "px ").concat(-lat, "px ").concat(color, "}\n    35% {height: ").concat(cssValue(size), "; box-shadow: ").concat(offset, "px 0 ").concat(color, ", ").concat(-offset, "px 0 ").concat(color, "}\n    70% {height: ").concat(thickness, "px; box-shadow: ").concat(offset, "px ").concat(-lat, "px ").concat(color, ", ").concat(-offset, "px ").concat(lat, "px ").concat(color, "}\n    100% {box-shadow: ").concat(offset, "px ").concat(lat, "px ").concat(color, ", ").concat(-offset, "px ").concat(-lat, "px ").concat(color, "}"), "after");

  var style = function style(i) {
    return {
      position: "absolute",
      top: "50%",
      left: "50%",
      display: "block",
      width: "".concat(value / 5).concat(unit),
      height: "".concat(value / 5).concat(unit),
      borderRadius: "".concat(value / 10).concat(unit),
      transform: "translate(-50%, -50%)",
      animationFillMode: "none",
      animation: "".concat(i === 1 ? before : after, " ").concat(2 / speedMultiplier, "s infinite")
    };
  };

  if (!loading) {
    return null;
  }

  return React.createElement("span", __assign({
    style: wrapper
  }, additionalprops), React.createElement("span", {
    style: style(1)
  }), React.createElement("span", {
    style: style(2)
  }));
}

export default HashLoader;